import { Modal } from "@pepperstone/pepper-ui-kit";

import { useBodyScrollLock } from "../hooks/useBodyScrollLock";
import { CrossIcon } from "../Icons";

type CheckboxProps = {
  tooltipText: string;
  isOpen: boolean;
  onClose: () => void; // Function to close the modal
};

export const TooltipModal: React.FC<CheckboxProps> = ({
  tooltipText,
  isOpen,
  onClose,
}) => {
  useBodyScrollLock(isOpen);

  if (!isOpen) return null;

  return (
    <div
      id="modal-overlay"
      data-testid="modal-overlay"
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={() => onClose()}
    >
      <div className="fixed inset-0 bg-black opacity-50"></div>
      <Modal
        content={
          <div>
            <div className="flex justify-end">
              <CrossIcon onClick={() => onClose()} />
            </div>
            <div>{tooltipText}</div>
          </div>
        }
        isVisible={isOpen}
        position="center"
        size="normal"
        maxWidth={602}
        // @ts-ignore
        className="mb-32"
      />
    </div>
  );
};
